import React from "react";
import { Link, Span, Text } from "@catchoftheday/cg-components";
import { CATCH_SELLER_ID } from "../../../../consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SellerInformation = function SellerInformation(_ref) {
  var _ref$shipping = _ref.shipping,
      soldByCatch = _ref$shipping.soldByCatch,
      isFBC = _ref$shipping.isFBC,
      _ref$seller = _ref.seller,
      sellerId = _ref$seller.id,
      name = _ref$seller.name,
      slug = _ref$seller.slug,
      offerId = _ref.offerId,
      isGiftCard = _ref.isGiftCard;
  return ___EmotionJSX(React.Fragment, null, !soldByCatch && ___EmotionJSX(Span, {
    display: "inline-block",
    backgroundColor: "primary",
    color: "textWhite",
    fontSize: "xs",
    lineHeight: "12px",
    fontWeight: "medium",
    p: "4px 6px",
    mb: "5px"
  }, "Marketplace Seller"), !isGiftCard && ___EmotionJSX(Text, {
    m: 0,
    "data-testid": "sold-by"
  }, "Sold", isFBC ? "" : " and delivered", " by", " ", slug && sellerId !== CATCH_SELLER_ID ? ___EmotionJSX(Link, {
    href: "/seller/".concat(slug, "?oid=").concat(offerId, "#popular_products")
  }, name) : ___EmotionJSX(Span, {
    fontWeight: "400"
  }, name), isFBC && ". Delivered by Catch"));
};